import React from "react";
import { Carousel } from 'antd';
import styles from "./sliders.module.scss"
import Heading from "../heading";


interface IProps{
    data: any[];
}

const Sliders=({data}:IProps)=>{
    return(
       <>
       <Heading heading="OUR CLIENTS" headingClassname={styles["title"]}/>
        <Carousel arrows autoplay infinite={true} className={styles["wrapper"]} autoplaySpeed={200000} dots  >
            {data.map((item:any, index:number) => (
                <div key={index} >
                    {/* <h3 className={styles["title"]}>{item.title}</h3> */}
                    <p className={styles["content"]}>{item.content}</p>
                </div>
                ))}
      </Carousel>
       </>
    )
}
export default Sliders;